import React from 'react';
import TwoPlayerGame from './TwoPlayerGame/TwoPlayerGame';

function App() {
	return (
		<TwoPlayerGame />
	)
}

export default App;